import { contentType } from '../../../utils/ActionTypes';
import { createReducerWraper } from '../../../utils/Reducer';

export const customerListReducer = createReducerWraper(contentType.CUSTOMER_LIST);
